import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  display: flex;\n  padding: 28px;\n  padding-right: 69px;\n  background-color: #fff;\n  min-height: 201px;\n  border-radius: 6px;\n  box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 2px 0px, rgba(0, 0, 0, 0.04) 0px 3px 3px 0px;\n  @media (max-width: 1200px) {\n    padding: 16px;\n    padding-right: 83px;\n    width: 100%;\n  }\n\n  .ant-skeleton.ant-skeleton-element .ant-skeleton-avatar {\n    width: 120px;\n    height: 145px;\n    background-color: #e7e7e9;\n    border-radius: 4px;\n    @media (max-width: 1200px) {\n      width: 78px;\n      height: 94px;\n    }\n  }\n\n  .contents {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    margin-left: 16px;\n    width: 100%;\n\n    .content-top {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      @media (max-width: 1200px) {\n        gap: 4px;\n      }\n\n      .ant-skeleton.ant-skeleton-element {\n        .ant-skeleton-input {\n          height: 28px;\n          width: 100%;\n          background-color: #e7e7e9;\n          border-radius: 4px;\n          @media (max-width: 1200px) {\n            height: 20px;\n          }\n        }\n\n        .ant-skeleton-button {\n          height: 20px;\n          width: 91px;\n          background-color: #e7e7e9;\n          border-radius: 4px;\n          @media (max-width: 1200px) {\n            height: 16px;\n            width: 103px;\n          }\n        }\n      }\n    }\n\n    .content-bottom {\n      gap: 8px;\n      display: flex;\n      flex-direction: column;\n\n      .ant-skeleton.ant-skeleton-element {\n        .ant-skeleton-input {\n          height: 28px;\n          width: 119px;\n          background-color: #e7e7e9;\n          border-radius: 4px;\n          @media (max-width: 1200px) {\n            height: 20px;\n            width: 86px;\n            min-width: 86px;\n            margin-bottom: 18px;\n          }\n        }\n      }\n\n      .tags-wrapper {\n        display: flex;\n        gap: 6px;\n        @media (max-width: 1200px) {\n          display: none;\n        }\n\n        .ant-skeleton.ant-skeleton-element {\n          &:nth-last-child(2) {\n            display: none;\n          }\n\n          .ant-skeleton-button {\n            height: 20px;\n            width: 65px;\n            background-color: #e7e7e9;\n            border-radius: 4px;\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from "antd";
import React from "react";
import styled from "styled-components";
export const SkeletonListItem = (param)=>{
    let {} = param;
    const active = true;
    const buttonShape = "default";
    const size = "default";
    const block = false;
    const avatarShape = "square";
    return /*#__PURE__*/ _jsxs(SkeletonListItemWrapper, {
        className: "item-wrapper",
        children: [
            /*#__PURE__*/ _jsx(Skeleton.Avatar, {
                active: active,
                size: size,
                shape: avatarShape
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "contents",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "content-top",
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                active: active,
                                size: size
                            }),
                            /*#__PURE__*/ _jsx(Skeleton.Button, {
                                active: active,
                                size: size,
                                shape: buttonShape,
                                block: block
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "content-bottom",
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                active: active,
                                size: size
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "tags-wrapper",
                                children: [
                                    /*#__PURE__*/ _jsx(Skeleton.Button, {
                                        active: active,
                                        size: size,
                                        shape: buttonShape,
                                        block: block
                                    }),
                                    /*#__PURE__*/ _jsx(Skeleton.Button, {
                                        active: active,
                                        size: size,
                                        shape: buttonShape,
                                        block: block
                                    }),
                                    /*#__PURE__*/ _jsx(Skeleton.Button, {
                                        active: active,
                                        size: size,
                                        shape: buttonShape,
                                        block: block
                                    }),
                                    /*#__PURE__*/ _jsx(Skeleton.Button, {
                                        active: active,
                                        size: size,
                                        shape: buttonShape,
                                        block: block
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const SkeletonListItemWrapper = styled.div.withConfig({
    componentId: "sc-e8c7ec9d-0"
})(_templateObject());
